module.exports = __webpack_public_path__ + "src/img/artist/indexpic07.jpg?012d373cf7a96ecb0a0476596f2390ce";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/indexpic07.jpg
// module id = 134
// module chunks = 0